import axios from 'axios';
import { environments } from './environments';
import { firebaseApp } from '../firebase';

const instance = axios.create({
  baseURL: environments.CofeCoreServiceURL,
});

instance.defaults.headers.common['API-TOKEN'] = process.env.API_TOKEN;

instance.interceptors.request.use(
  async config => {
    const token = await firebaseApp.auth().currentUser?.getIdToken();
    config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

export default instance;
